export default "__VITE_ASSET__DMLchX7H__"